import { createFileRoute } from "@tanstack/react-router";
import { useAlertRuleEvents, useMarkAlertRuleEventRead, useVehicles } from "@/hooks/queries";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle, Bell } from "lucide-react";
import { WaitingBackend } from "@/components/waiting-backend";

export const Route = createFileRoute("/alerts")({
  component: AlertsPage,
  head: () => ({ meta: [{ title: "Alertas — Wp Rastreamento" }] }),
});

// Motor de alertas real (Fase 3, GPS Drive Backend) — antes esta página
// lia mockAlerts. Sem deviceId, useAlertRuleEvents já traz a frota
// inteira da empresa (ver alerts.service.ts/notifications module no
// backend).
function AlertsPage() {
  const { data, isLoading, error } = useAlertRuleEvents();
  const { data: vehicles } = useVehicles();
  const markRead = useMarkAlertRuleEventRead();

  const vehicleNameByDeviceId = new Map((vehicles ?? []).map((v) => [Number(v.id), v.name]));

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Alertas</h1>
        <p className="text-sm text-muted-foreground">Notificações e ocorrências da frota.</p>
      </div>
      {isLoading || error || !data ? (
        <WaitingBackend error={error} />
      ) : (
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-base">
              <AlertTriangle className="h-4 w-4" /> {data.filter((a) => !a.read).length} não lidos
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {data.map((a) => (
              <button
                key={a.id}
                type="button"
                onClick={() => !a.read && markRead.mutate(a.id)}
                className={`flex w-full items-start gap-3 rounded-lg border p-4 text-left ${!a.read ? "bg-muted/40" : ""}`}
              >
                <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-muted">
                  <Bell className="h-4 w-4" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-medium">
                      {vehicleNameByDeviceId.get(a.traccarDeviceId) ?? `Veículo ${a.traccarDeviceId}`}
                    </span>
                    {!a.read && <span className="h-2 w-2 rounded-full bg-primary" />}
                  </div>
                  <p className="mt-1 text-sm text-muted-foreground">{a.message}</p>
                  <p className="mt-1 text-xs text-muted-foreground">
                    {new Date(a.firedAt).toLocaleString("pt-BR")}
                  </p>
                </div>
              </button>
            ))}
            {data.length === 0 && (
              <p className="py-8 text-center text-sm text-muted-foreground">Nenhum alerta.</p>
            )}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
